import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import IFrame2 from "../IFrame2";
import { Loading } from "../UI/loading";
import { getToolsList } from "./api";

export default function LoadTools() {
  // @ts-ignore
  const { toolId } = useParams();

  const [data, setData] = useState({
    url: "",
  });

  useEffect(() => {
    async function initialLoad() {
      const ToolsList = await getToolsList();
      const url = await ToolsList.filter((tool) => tool?.Tool?.id === toolId)[0]
        ?.Tool?.ConnectionDetail?.toolsURL;
      setData({
        ...data,
        url: url,
      });
    }
    initialLoad();
  }, []);

  return <>{data.url.length > 0 ? <IFrame2 url={data.url} /> : <Loading />}</>;
}
